/**
 * アプリケーション全体で使用するメッセージ
 */
export const successMessages = {
    // 操作完了通知
    operation: {
        created: '登録完了',
        deleted: '削除完了',
    },
    signup: {
        completed: 'アカウント登録が完了しました。',
        resend: '認証コードを送信しました。',
    },

};
export const errorMessages = {

    signup: {
        failed: 'アカウント登録に失敗しました。しばらくしてから再度お試しください。',
        authentication_failed: '認証に失敗しました。認証コードが正しいかご確認ください。',
        send_code_failed: '認証コードの送信に失敗しました。しばらくしてから再度お試しください。',
        resend_failed_email_not_found: 'メールアドレスが見つかりません。',
    },

    login: {
        invalid_credentials: 'メールアドレスまたはパスワードが違います。',
        login_failed: 'ログインに失敗しました。しばらくしてから再度お試しください。',
        session_expired: 'ログインの有効期限が切れました。再度ログインしてください。',
        too_many_attempts: 'ログイン試行回数が制限を超えました。15分後に再度お試しください。',
    },

    password_reset: {
        token_invalid: 'パスワードリセットリンクが無効です。',
        token_expired: 'パスワードリセットリンクの有効期限が切れています。',
        failed: 'パスワードリセットに失敗しました。',
    },

    google: {
        token_not_verified: 'Googleアカウントの認証に失敗しました。',
        not_found: 'サービスが一時的に利用できません。<br>しばらく時間をおいてから再度お試しください。',
        popup_blocked: 'ポップアップがブロックされました。<br>ブラウザの設定でポップアップを許可してください。',
        network_request_failed: 'ネットワークエラーが発生しました。<br>インターネット接続を確認してください。',
        unauthorized_domain: 'このドメインは認証が許可されていません。<br>管理者に連絡してください。',
        auth_failed: 'Googleログインに失敗しました。<br>もう一度お試しいただくか、通常のログインをご利用ください。',
    },

    // 基本的なCRUD操作や一般的な操作のエラー 
    common: {
        validation_error: '適切ではない入力値が見つかりました。',
        data_not_found: '対象のデータが見つかりません。',
        data_fetch_failed: 'データの取得に失敗しました。<br>しばらくしてから再度お試しください。',
        registration_failed: '登録に失敗しました。<br>しばらくしてから再度お試しください。',
        send_mail_failed: 'メールの送信に失敗しました。<br>しばらくしてから再度お試しください。',
        update_failed: '更新に失敗しました。<br>しばらくしてから再度お試しください。',
    },

    projects: {
        not_found: '対象のプロジェクトが見つかりません。',
    },

    skillsheets: {
        delete_failed: 'スキルシートの削除に失敗しました。',
        copy_url_failed: 'URLのコピーに失敗しました。<br>手動でURLをコピーしてください。',
    },

    works: {
        portfolio_fetch_failed: 'ポートフォリオの取得に失敗しました。<br>しばらくしてから再度お試しください。',
        upload_file_size_exceeded: 'ファイルサイズが5MBを超えています。<br>小さなファイルを選択してください。',
        upload_file_format_invalid: 'PDFファイルのみアップロード可能です。',
        upload_failed: 'ファイルアップロードに失敗しました。<br>しばらくしてから再度お試しください。',
    },

    webcv: {
        not_found : '参照できるスキルシートが見つかりません。',
        export_failed: 'スキルシート出力に失敗しました。<br>しばらくしてから再度お試しください。',
        not_enough_data: 'スキルシートの出力に必要なデータ(プロフィール・プロジェクト)が不足しています。',
    },

    pdf: {
        generate_failed: 'PDFの生成中に問題が発生しました。<br>しばらくしてから再試行してください。',
    },

    account_settings: {
        invalid_password: '現在のパスワードが間違っています。',
        send_code_failed: '認証コードの送信に失敗しました。しばらくしてから再度お試しください。',
        password_change_failed: 'パスワード変更に失敗しました。しばらくしてから再度お試しください。',
        invalid_mailaddress: 'このメールアドレスは使用できません。別のメールアドレスを入力して下さい。',
        authentication_failed:'認証に失敗しました。認証コードが正しいかご確認ください。'
    },

    // インフラストラクチャレベルのエラー
    api: {
        network_error: '通信エラーが発生しました。インターネット接続を確認してください。',
        server_error: 'サーバーで問題が発生しました。<br>しばらくしてから再度お試しください。',
        not_found: '要求されたリソースが見つかりませんでした',
        too_many_requests: 'リクエスト制限を超えました。<br>しばらくしてから再度お試しください。。',
    },
};



export default { successMessages, errorMessages };